import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import "../Form.css";
import useForm from "react-hook-form";
import vars from "../../utils/variables";

const DeleteAppointment = ({ history }) => {
  const id = history.location.state.id;
  const [error, setError] = useState(false);

  const { handleSubmit } = useForm();

  const handleFetch = () => {
    fetch(`${vars.server}/appointments/delete/` + id, {
      method: "POST",
      body: JSON.stringify(),
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "include"
    })
      .then(response => {
        return response.json();
      })
      .then(result => {
        if (result.success) {
          history.push("/medicalrecords", { state: { id: id } });
        } else {
          setError(result.message);
        }
      });
  };

  return (
    <form onSubmit={handleSubmit(handleFetch)} className="formForm">
      <h1>Termin löschen</h1>
      {error && <p className="errorMessage">Fehler: {error}</p>}
      <p>Um den Termin vollständig und unwiderruflich zu löschen, bestätigen Sie mit "Termin löschen".</p>
      <br />
      <input type="submit" value="Termin löschen" className="inputRLSubmit delete" />
    </form>
  );
};

export default withRouter(DeleteAppointment);
